
        import 'TheEnd.e8edd8f.css-module'
        export default {"TheEnd":"TheEnd_TheEnd_e8edd8f","instructions":"instructions_TheEnd_e8edd8f","remail":"remail_TheEnd_e8edd8f","exitButton":"exitButton_TheEnd_e8edd8f","homeButton":"homeButton_TheEnd_e8edd8f"}
    